import { SuburbAndStreetsModel } from "@/api/Shared";
import axios from "axios";
import { executeApiRequest } from "@/plumbing/http/apiClient";

export type ListSuburbsResponse = {
  suburbs: SuburbAndStreetsModel[];
};

export const listSuburbs = async () => {
  const response = await executeApiRequest(() => axios.get<ListSuburbsResponse>("/suburbs"));
  return response?.data;
};
